import { Route, Routes } from 'react-router-dom';

import BusinessIntroductionDE from '../BusinessIntroductionDE';
import PersonalInformationDE from '../PersonalInformationDE/PersonalInformation';
import RouteLoader from '../RouteLoader/RouteLoader';
import TradingHistory from '../TradingHistoryV2/TradingHistory';

const SignupRoutesDE = () => {
    return (
        <>
            <Routes>
                {/* TODO: Add DE routes */}
                <Route path="/schritt-1" element={<BusinessIntroductionDE />} />
                <Route path="/schritt-2" element={<PersonalInformationDE />} />
                <Route path="/schritt-3" element={<TradingHistory />} />

                {/* Fallback route */}
                <Route path={'/*'} element={<RouteLoader />} />
            </Routes>
        </>
    );
};

export default SignupRoutesDE;
